import React, { useCallback } from 'react'
import styles from './styles.module.less'
import { Button, Popconfirm, Dropdown, Menu, Tooltip } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { orderStatus } from '@/models/orders/defines/constants'
import {
  setCompleteStatus,
  toggleOrderTag,
  setWorkerComplete,
  setAcceptStatus,
  showReServiceDialog,
  showOrderEvaluateDialog,
  showAppealDialog,
} from '@/models/orders/actions'
import { getCurrentUser } from '@/models/user/selectors';

export default function ControlBtns(props) {
  const {
    orderId,
    order,
    tenantMode,
    workerFeeTotal, // 师傅费用总计
  } = props
  const dispatch = useDispatch()
  const user = useSelector(getCurrentUser);
  const hasWorker = order?.get('worker')
  const workerCompleted = order?.get('worker_completed')
  const platformChecked = order?.get('platform_checked')
  const waitTenantConfirmStatus = order?.get('status_code') === orderStatus.PROCESSING_WAIT_TENANT_RECEIPT

  const showExpressBtn = !tenantMode && hasWorker && !workerCompleted && !platformChecked
  const showSetFaildBtn = !tenantMode && hasWorker && !workerCompleted
  const showConfirmBtn = !tenantMode && hasWorker && workerCompleted && !platformChecked
  const showTenantConfirmBtn = tenantMode && waitTenantConfirmStatus && platformChecked

  const toggleFaildTag = useCallback(() => {
    dispatch(toggleOrderTag(orderId, 'TAG_SERVICE_FAILD'))
  }, [orderId])
  const toggleWaitExpressTag = useCallback(() => {
    dispatch(toggleOrderTag(orderId, 'TAG_WAIT_EXPRESS'))
  }, [orderId])
  const toggleWaitSendExpressTag = useCallback(() => {
    dispatch(toggleOrderTag(orderId, 'TAG_WAIT_SEND_EXPRESS'))
  }, [orderId])
  const reServiceDialog = useCallback(() => {
    dispatch(showReServiceDialog({
      id: orderId,
      order: order,
      dispatch
    }))
  }, [orderId])

  const handleCompleteStatus = useCallback(() => {
    dispatch(setCompleteStatus(orderId))
  }, [orderId])
  const handleWorkerComplete = useCallback(() => {
    dispatch(setWorkerComplete(orderId))
  })
  const refuseAccept = useCallback((e) => {
    dispatch(setAcceptStatus(orderId, e.key))
  })

  // if (!showExpressBtn && !showConfirmBtn && !showSetFaildBtn && !showTenantConfirmBtn) {
  //   return null
  // }
  const menu = (
    <Menu onClick={refuseAccept}>
      <Menu.Item key="照片不规范">照片不规范</Menu.Item>
      <Menu.Item key="核实未完成">核实未完成</Menu.Item>
      <Menu.Item key="待返件">待返件(商家可见)</Menu.Item>
      <Menu.Item key="待发件">待发件(商家可见)</Menu.Item>
    </Menu>
  )
  if (platformChecked) { return <></> }
  return (
    <>
      {/*
          showSetFaildBtn && (
            <Button
              onClick={toggleFaildTag}
              className={styles.ctrlBtn}
              type={order?.tags?.includes('TAG_SERVICE_FAILD') ? 'primary': 'default'}
              size="small">上门失败</Button>
          )*/
      }
      {
        /*
        showExpressBtn && (
          <>
            <Button
              onClick={toggleWaitExpressTag}
              className={styles.ctrlBtn}
              type={order?.tags?.includes('TAG_WAIT_EXPRESS') ? 'primary': 'default'}
              size="small">等待返件</Button>
            <Button
              onClick={toggleWaitSendExpressTag}
              className={styles.ctrlBtn}
              type={order?.tags?.includes('TAG_WAIT_SEND_EXPRESS') ? 'primary': 'default'}
              size="small">等待发件</Button>
          </>
        )*/
      }
      {/* {
        showConfirmBtn && (
          <> */}


      {/* <Dropdown.Button overlay={menu} placement="topLeft" type="primary" size="small" className={styles.ctrlBtn}>
                {order.payer_type === 1 ? '拒绝验收' : '拒绝结算'}
              </Dropdown.Button> */}
      {
        ((
          process.env.APP_MODE === 'manager' ||
          (tenantMode && order?.get('ticket_type') == 2)
        ) &&
          order?.get('status_code') === orderStatus.PROCESSING_COMPLETED) && <>
          <Button size="small" block shape="round" type="primary" ghost
            onClick={reServiceDialog}>
            再次上门
          </Button>

          <Dropdown overlay={(
            <Menu>
              <Menu.Item>
                <Button block type="link"
                  onClick={() => { refuseAccept({ key: '照片不规范' }) }}>照片不规范</Button>
              </Menu.Item>
              <Menu.Item>
                <Button block type="link"
                  onClick={() => { refuseAccept({ key: '核实未完成' }) }}>核实未完成</Button>
              </Menu.Item>
            </Menu>
          )} placement="topRight">
            <Button size="small" block shape="round" type="primary" ghost>未完成</Button>
          </Dropdown>
        </>
      }

      {
        (
          // order.get('ticket_type') != 2 &&
          (!tenantMode && order?.get('worker_completed')) ||
          (tenantMode && order?.get('ticket_type') == 2 && order?.get('worker_completed'))
        ) && (
          process.env.APP_MODE === 'manager' && order?.get('is_retail') ? (
            <Tooltip title="保外工单，客服不能确认结算">
              <Button size="small" block type="primary" shape="round" disabled>
                {order.payer_type === 1 ? '确认验收' : '确认结算'}
              </Button>
            </Tooltip>
          ) : (
            <Popconfirm
              placement="topRight"
              title={(
                <>
                  {workerFeeTotal > order?.get('fee_total') ?
                    <div>该工单亏损，确认结算？</div>
                    :
                    <div>
                      {
                        order.payer_type === 1 && (
                          <div>企业工单（保内）需要企业确认后再结算。</div>
                        )
                      }
                      {
                        order.payer_type === 2 && (
                          <div>确认会立即结算，不可逆。</div>
                        )
                      }
                      <div>请谨慎操作！</div>
                    </div>
                  }
                </>
              )}
              onConfirm={handleCompleteStatus}
              okText="确定"
              cancelText="取消" >
              <Button size="small" block type="primary" shape="round">
                {order.payer_type === 1 ? '确认验收' : '确认结算'}
              </Button>
            </Popconfirm>
          )
        )
      }

      {
        (
          process.env.APP_MODE === 'tenant' && (
            order?.get('status_code') === orderStatus.DONE ||
            order?.get('status_code') === orderStatus.DONE_CLOSE
          )
        ) && (<>
          <Button size="small" block shape="round"
            onClick={() => {
              dispatch(showOrderEvaluateDialog({ orderId, workerId: order.getIn(['worker', '_id']) }))
            }}>工单评价</Button>
        </>)
      }
      {
        (process.env.APP_MODE === 'tenant' &&
          (
            (order?.get('status_code') === orderStatus.PROCESSING_COMPLETED && order?.get('ticket_type') == 1) ||
            (order?.get('status_code') === orderStatus.DONE_CLOSE)
          )
        ) && (<>
          <Button size="small" block shape="round"
            onClick={() => {
              dispatch(
                showAppealDialog({
                  title: '申诉/索赔',
                  order: order?.toJS(),
                  appeal: order?.get('appeal')?.toJS(),
                  order_id: orderId,
                  type: 1, //申请类型 0 商家申请返款 1申请对师傅扣款 2申请对商家扣款
                  isAppealClaim: true,
                  user: user
                })
              )
            }}>申诉/索赔</Button>

        </>)
      }
      {/* </>
        )
      } */}
      {/* {
        showTenantConfirmBtn && (
          <Button
            block
            type="primary"
            shape="round"
            onClick={handleCompleteStatus}>
            确认结算
          </Button>
        )
      } */}
      {/* {
        (process.env.APP_MODE === 'tenant' && waitTenantConfirmStatus) && (
          <Button
            block
            type="primary"
            shape="round"
            onClick={handleCompleteStatus}>
            确认结算
          </Button>
        )
      } */}
      {/* {
          true && (
            <Popconfirm
              title="危险操作! 不到万不得已请勿代师傅操作！"
              onConfirm={handleWorkerComplete}
              okText="确定"
              cancelText="取消" >
              <Button
                type="default"
                size="small"
                className={styles.ctrlBtn}>
                替师傅完单
              </Button>
            </Popconfirm>
          )
        } */}
    </>
  )
}
